export default __webpack_public_path__ + "static/media/SENAIT_FR_SEQ20.df46492a.mp3";